import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import Header from './header';
import Navbar from './navbar';
import Sidebar from './sidebar';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import useAuth from './useAuth';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { FaDownload, FaEye, FaUser } from 'react-icons/fa';
import { getAuthToken } from '../../authToken';

const Profil_utilisateur = ({ titre }) => {
  useAuth(); // Vérifier l'authentification
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const user_id = localStorage.getItem('user_id');

  // Utilisation de useEffect pour mettre à jour le titre de la page
  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Profil"; // Définit le titre de la page
    }
  }, [user_id]);

  const [alert, setAlert] = useState({ message: '', type: '' });
  const showAlert = (message, type = 'success') => {
    setAlert({ message, type });
  };

  const fermerNotif = () => {
    setAlert({ message: '', type: '' });
  };

  const [userData, setUserData] = useState({
    email: '',
    nom: '',
    prenoms: '',
    tel: '',
    diplome: '',
    sexe: '',
    profession: '',
    type_financement: '',
    civilite: '',
    type_profil: '',
    nom_organisation: '',
    email_pro: '',
    email_corporate: ''
  });

  // Variable d'état pour stocker les données utilisateur initiales
  const [initialUserData, setInitialUserData] = useState(userData);

  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModif, setIsLoadingModif] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {

        const token = localStorage.getItem('access_token');

        const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
          method: 'get',
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        });
        if (!response.ok) throw new Error('Erreur réseau');
        const data = await response.json();
        console.log(data)
        setUserData(data);
        setInitialUserData(data);
        if (!data.tel) {
          showAlert("Veuillez renseigner les informations manquantes.", "warning")
        }
      } catch (error) {
        console.error('Erreur lors du chargement du profil:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [user_id]);

  const handleChange = (e) => {
    if (e && e.target && e.target.name) {
      setUserData({
        ...userData,
        [e.target.name]: e.target.value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoadingModif(true)
      const token = localStorage.getItem('access_token');

      const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${user_id}/${user_id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(userData)
      });
      if (!response.ok) throw new Error('Erreur réseau');
      const result = await response.json();

      // Afficher le message éphémère
      showAlert('Profil mis à jour avec succès.');
      navigate('/dashboard')
    } catch (error) {
      console.error('Erreur lors de la modification du profil:', error);
    } finally {
      setIsLoadingModif(false);
    }
  };

  // Gérer les changements du champ de téléphone (numéro complet + indicatif pays)
  const handlePhoneChange = (value) => {
    setUserData({
      ...userData,
      tel: value,
    });
  };

  const handleReset = () => {
    setUserData(initialUserData); // Réinitialiser aux valeurs initiales
  };

  const handleDownload = async () => {
    try {
      const token = localStorage.getItem('access_token');

      const downloadUrl = `${process.env.REACT_APP_HOTE}/telecharger-attestation/${userData.id}/`;

      // Vérification d'existence via une simple requête GET avec token
      const checkResponse = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!checkResponse.ok) {
        if (checkResponse.status === 404) {
          throw new Error("Attestation non disponible.");
        } else if (checkResponse.status === 401) {
          throw new Error("Non autorisé. Veuillez vous reconnecter.");
        } else {
          throw new Error(`Erreur ${checkResponse.status}: ${checkResponse.statusText}`);
        }
      }

      // Téléchargement réel
      const blob = await checkResponse.blob();
      const url = window.URL.createObjectURL(blob);

      // Récupérer le nom du fichier depuis l'en-tête Content-Disposition
      const contentDisposition = checkResponse.headers.get("content-disposition");
      let filename = `attestation_${userData.nom}_${userData.prenoms}.pdf`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      // Nettoyage
      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Téléchargement réussi !", "success");

    } catch (error) {
      console.error("Erreur lors du téléchargement:", error);
      showAlert(error.message || "Une erreur s'est produite lors du téléchargement", "danger");
    }
  };

  const [previewFile, setPreviewFile] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const handlePrevisualisation = async () => {
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/previsualisation-attestation/${userData.id}/${user_id}/`,
        {
          method: 'GET',
          headers: {
            // 'Accept': 'application/pdf, image/*',
            'Authorization': `Bearer ${token}` // Ajout du token
          }
        }
      );

      if (!response.ok) {
        let errorMessage = 'Erreur lors de la récupération du fichier';

        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch {
          if (response.status === 404) {
            errorMessage = "Aucun fichier d'attestation trouvé pour cet utilisateur";
          } else if (response.status === 401) {
            errorMessage = "Non autorisé. Veuillez vous reconnecter.";
          } else {
            errorMessage = `Erreur ${response.status}: ${response.statusText}`;
          }
        }

        throw new Error(errorMessage);
      }

      const contentType = response.headers.get('content-type');
      const blob = await response.blob();

      // Vérifier que le blob n'est pas vide
      if (blob.size === 0) {
        throw new Error("Le fichier est vide");
      }

      // Créer une URL pour le blob
      const fileUrl = window.URL.createObjectURL(blob);

      // Déterminer le type de fichier
      let fileType = 'other';
      let fileExtension = 'file';

      if (contentType) {
        if (contentType.includes('pdf')) {
          fileType = 'pdf';
          fileExtension = 'pdf';
        } else if (contentType.includes('image')) {
          fileType = 'image';
          fileExtension = contentType.split('/')[1] || 'jpg';
        }
      }

      setPreviewFile({
        url: fileUrl,
        type: fileType,
        name: `${userData.nom}_${userData.prenoms}_attestation.${fileExtension}`
      });

      setShowPreviewModal(true);

    } catch (error) {
      console.error("Erreur de prévisualisation:", error);
      showAlert(error.message || "Impossible de prévisualiser le fichier", "danger");
    }
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className='d-flex align-items-center'><FaUser size={25} className='mr-2' />Mon Profil</h2>
              <small>Ici vous pouvez consulter ou modifier vos Informations.</small>

              <small id='hbreadcrumb' className='d-flex justify-content-end'>
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    {/* Utiliser Link de react-router-dom pour la navigation */}
                    <Link to={`/Profil-utilisateur`}>Mon Profil</Link>
                  </li>
                </ol>
              </small>
            </div>
          </div>
          <div className="container mt-5 wrapper wrapper-content animated fadeInRight">
            <div className="row">
              <div className="col-lg-2"></div>
              <div className="col-lg-8">
                {alert.message && (
                  <div className={`alert alert-${alert.type} row justify-content-between position-relative m-1 mb-2`}>
                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                    <span
                      onClick={fermerNotif}
                      style={{
                        position: 'absolute',
                        top: '0px',
                        right: '10px',
                        cursor: 'pointer'
                      }}
                    >
                      <i className='fa fa-close'></i>
                    </span>
                  </div>
                )}
                <div className="hpanel mb-5">
                  <div className="panel-body styled-panel">

                    <div className="mb-4 text-center">
                      <i className="fa fa-user-circle login-logo" style={{ fontSize: '50px' }}></i>
                    </div>
                    <h3 className="font-bold text-center">Consultez votre profil</h3>
                    {isLoading ? (
                      <div className="text-center">
                        <p>Chargement des données...</p> {/* Affichage d'un message de chargement */}
                      </div>
                    ) : (
                      <Form onSubmit={handleSubmit} className="reg-page">
                        <Row>
                          {/* Civilité */}
                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="civilite">
                              <Form.Label>Civilité</Form.Label>
                              <Form.Select
                                name="civilite"
                                value={userData.civilite}
                                onChange={handleChange}
                                className="custom-select"
                              >
                                <option value="">Choisir la civilité</option>
                                <option value="Monsieur">Monsieur</option>
                                <option value="Madame">Madame</option>
                                <option value="Mademoiselle">Mademoiselle</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          {/* Type de profil */}
                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="type_profil">
                              <Form.Label>Type de profil</Form.Label>
                              <Form.Select
                                name="type_profil"
                                value={userData.type_profil}
                                onChange={handleChange}
                                className="custom-select"
                              >
                                <option value="">Choisir le type de profil</option>
                                <option value="Apprenant">Apprenant</option>
                                <option value="Partenaire">Partenaire</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="nom">
                              <Form.Label>Nom</Form.Label>
                              <Form.Control
                                type="text"
                                name="nom"
                                value={userData.nom}
                                onChange={handleChange}
                                className="custom-input"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="prenoms">
                              <Form.Label>Prénoms</Form.Label>
                              <Form.Control
                                type="text"
                                name="prenoms"
                                value={userData.prenoms}
                                onChange={handleChange}
                                className="custom-input"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="email">
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                placeholder={userData.email}
                                value={userData.email}
                                onChange={handleChange}
                                // readOnly
                                className="custom-input"
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="tel">
                              <Form.Label>Téléphone WhatsApp</Form.Label>
                              <PhoneInput
                                value={userData.tel}
                                onChange={handlePhoneChange}
                                inputStyle={{ width: '100%', padding: '33px' }}
                                containerStyle={{ width: '100%' }}
                                inputProps={{
                                  name: 'tel',
                                  required: true,
                                }}
                                dropdownStyle={{
                                  maxHeight: '500px',
                                  overflowY: 'auto',
                                  zIndex: 1050,
                                }}
                              />
                            </Form.Group>
                          </Col>

                          {/* Champs organisation pour partenaire */}
                          {userData.type_profil === 'Partenaire' && (
                            <>
                              <Col md={6}>
                                <Form.Group className="mb-3" controlId="nom_organisation">
                                  <Form.Label>Nom de l'organisation</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="nom_organisation"
                                    value={userData.nom_organisation}
                                    onChange={handleChange}
                                    className="custom-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3" controlId="email_corporate">
                                  <Form.Label>Email de l'organisation</Form.Label>
                                  <Form.Control
                                    type="email"
                                    name="email_corporate"
                                    value={userData.email_corporate}
                                    onChange={handleChange}
                                    className="custom-input"
                                  />
                                </Form.Group>
                              </Col>
                            </>
                          )}


                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="email_pro">
                              <Form.Label>Email professionnel</Form.Label>
                              <Form.Control
                                type="email"
                                name="email_pro"
                                value={userData.email_pro}
                                onChange={handleChange}
                                className="custom-input"
                              />
                            </Form.Group>
                          </Col>

                          {/* Champs pour Apprenant */}
                          {userData.type_profil === 'Apprenant' && (
                            <>
                              <Col md={6}>
                                <Form.Group className="mb-3" controlId="profession">
                                  <Form.Label>Profession</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="profession"
                                    value={userData.profession}
                                    onChange={handleChange}
                                    className="custom-input"
                                  />
                                </Form.Group>
                              </Col>

                              <Col md={6}>
                                <Form.Group className="mb-3" controlId="type_financement">
                                  <Form.Label>Type de financement</Form.Label>
                                  <Form.Select
                                    name="type_financement"
                                    value={userData.type_financement}
                                    onChange={handleChange}
                                    className="custom-select"
                                  >
                                    <option value="">Choisir type de financement</option>
                                    <option value="Particulier">Particulier</option>
                                    <option value="Entreprise">Entreprise</option>
                                  </Form.Select>
                                </Form.Group>
                              </Col>


                              <Col md={6}>
                                <Form.Group className="mb-3" controlId="diplome">
                                  <Form.Label>Diplôme le plus élevé</Form.Label>
                                  <Form.Select
                                    name="diplome"
                                    value={userData.diplome}
                                    onChange={handleChange}
                                    className="custom-select"
                                  >
                                    <option value="">Diplôme le plus élevé</option>
                                    <option value="BAC">BAC</option>
                                    <option value="BTS">BTS</option>
                                    <option value="Licence">Licence</option>
                                    <option value="Master1">Master1</option>
                                    <option value="Master2">Master2</option>
                                    <option value="Doctorat">Doctorat</option>
                                    <option value="Ingénieur">Ingénieur</option>
                                    <option value="Autres">Autres</option>
                                  </Form.Select>
                                </Form.Group>
                              </Col>

                              {userData.type_financement === 'Particulier' && (
                                <>

                                  {/* <Col md={6}>
                                    <Form.Group className="mb-3" controlId="sexe">
                                      <Form.Label>Sexe</Form.Label>
                                      <Form.Select
                                        name="sexe"
                                        value={userData.sexe}
                                        onChange={handleChange}
                                        className="custom-select"
                                      >
                                        <option value="">Choisir sexe...</option>
                                        <option value="Masculin">Masculin</option>
                                        <option value="Féminin">Féminin</option>
                                      </Form.Select>
                                    </Form.Group>
                                  </Col> */}
                                </>
                              )}
                            </>
                          )}
                        </Row>

                        {userData.attestation === 'Oui' && (
                          <div className="alert alert-light border mb-4">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0">
                                <div className="bg-success bg-opacity-10 p-2 rounded-circle">
                                  <i className="fa fa-mortar-board text-white fs-4"></i>
                                </div>
                              </div>
                              <div className="flex-grow-1 ms-3 ml-2">
                                <h5 className="text-success mb-1">Attestation disponible</h5>
                                <p className="mb-2 small">Vous pouvez télécharger votre attestation de formation</p>
                              </div>
                              <div className="flex-shrink-0">
                                <Button variant="outline-success" size="sm" onClick={handlePrevisualisation} className="me-2 mr-2">
                                  <FaEye /> Visualiser
                                </Button>
                                <Button variant="success" size="sm" onClick={handleDownload}>
                                  <FaDownload /> Télécharger
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="text-center">
                          <Button type="button" variant="default" onClick={handleReset}>
                            Annuler
                          </Button>
                          {isLoadingModif ? (
                            <button className="btn btn-success mr-2" disabled>
                              <i className="fa fa-spinner fa-spin mr-1"></i>
                              <span className="d-none d-sm-inline ml-2">
                                Chargement...
                              </span>
                            </button>
                          ) : (
                            <Button type="submit" variant="success" className="ml-2">
                              Modifier
                            </Button>
                          )}
                        </div>
                      </Form>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-2"></div>
              <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} size="lg" centered>
                <Modal.Header>
                  <Modal.Title>Prévisualisation de votre attestation </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center" style={{ minHeight: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {previewFile ? (
                    <>
                      {previewFile.type === 'pdf' ? (
                        <iframe
                          src={previewFile.url}
                          title={previewFile.name}
                          style={{ width: '100%', height: '500px', border: 'none' }}
                        />
                      ) : previewFile.type === 'image' ? (
                        <img
                          src={previewFile.url}
                          alt={previewFile.name}
                          style={{ maxWidth: '100%', maxHeight: '500px' }}
                        />
                      ) : (
                        <div>
                          <p>Type de fichier non supporté pour la prévisualisation</p>
                          <a
                            href={previewFile.url}
                            download={previewFile.name}
                            className="btn btn-primary"
                          >
                            Télécharger le fichier
                          </a>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-muted">Chargement...</div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowPreviewModal(false)}>
                    Fermer
                  </Button>
                  {previewFile && (
                    <a
                      href={previewFile.url}
                      download={previewFile.name}
                      className="btn btn-success"
                    >
                      <FaDownload className="mr-2" />
                      Télécharger
                    </a>
                  )}
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profil_utilisateur;